import { render, staticRenderFns } from "./AnswerSubmitted.vue?vue&type=template&id=1a35bad2"
import script from "./AnswerSubmitted.vue?vue&type=script&lang=js"
export * from "./AnswerSubmitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports